<template>
    <AppScaffold grid>
        <Card v-if="data && !loading">
            <h1>{{ $tradFor(data.terms.name) }}</h1>
            <nav>
                <RoundedButton @click="$router.go(-1);">{{ $trad.common.cancel }}</RoundedButton>
                <RoundedButton @click="save">{{ $trad.common.save }}</RoundedButton>
            </nav>
            <table>
                <tbody>
                    <tr>
                        <td>{{ $trad.fasciaEditor.width }}</td>
                        <td><NumericInput v-model="fasciaConfig.width"></NumericInput></td>
                    </tr>
                    <tr>
                        <td>{{ $trad.fasciaEditor.height }}</td>
                        <td><NumericInput v-model="fasciaConfig.height"></NumericInput></td>
                    </tr>
                </tbody>
            </table>
        </Card>
        <Card v-else> <Loader :loading="true"></Loader> </Card>
    </AppScaffold>
</template>

<script>
import AppScaffold from "@/app-scaffold";
import TryLoad from "@/mixins/TryLoadMixin";
import componentService from "@/services/component";
import Loader from "@/components/loader/loader";
import Card from "./components/card";
import RoundedButton from "./components/rounded-button";
import NumericInput from "@/plano/components/number-input.vue";

export default {
    components: { AppScaffold, Loader, Card, RoundedButton, NumericInput },
    mixins: [TryLoad],
    data: () => ({
        data: undefined,
        fasciaConfig: {
            width: 0,
            height: 0
        }
    }),
    computed: {
        fasciaId() {
            return this.$route.params.id && Number.parseInt(this.$route.params.id, 10);
        },
        component() {
            return (
                this.data && {
                    ...this.data,
                    config: this.fasciaConfig
                }
            );
        }
    },
    created() {
        this.fetchFascia();
    },
    methods: {
        async fetchFascia() {
            this.data = await this.tryLoad(() => componentService.get(this.fasciaId));
            this.fasciaConfig = {
                ...this.fasciaConfig,
                ...this.data.config
            };
        },
        async save() {
            try {
                await componentService.updateConfig(this.fasciaId, {
                    width: Number.parseFloat(this.fasciaConfig.width, 10),
                    height: Number.parseFloat(this.fasciaConfig.height, 10)
                });
                this.$router.go(-1);
            } catch (err) {
                this.dialogError(err);
                throw err;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// fascia-editor.vue?2b5ef348